

import React, {useEffect, useState, useRef} from "react";
import PageHeader from "components/PageHeader";
import Faq from "components/Faq";
import Section from "components/Section";

import placeholderImg from 'assets/images/csango10-13kerulet-elado-lakasok-4.webp';
import Img from "components/Img";

import 'assets/css/PaymentInformations.min.css';

import zoldhitelImg from 'assets/images/zoldhitel.webp';
import csokImg from 'assets/images/csok.webp';
import otSzazalekImg from 'assets/images/ot-szazalek-afa.webp';
import molnarZoltan from 'assets/images/ertekesitok/molnar_zoltan.webp';
import boldogCsalad from 'assets/images/boldog-csalad-az-uj-lakasban.webp';

import routes from "configs/routes";

const PaymentInformations = () => {
    
    const widgetRef = useRef(null);

    const [loanClamps, setLoanClamps] = useState([]);


    /*useEffect(()=>{
        if( widgetRef.current ) {
            const script = document.createElement('script');
            script.id = "ex-widget-calc";
            script.src = "https://partnerportal.finex.hu/js/ex.js";

            script.setAttribute("data-id", "7");
            script.setAttribute("data-website", "113");
            script.setAttribute("data-hash", "8eb3175e41492dff2813c14a4481d15d");

            widgetRef.current.appendChild(script);
        }

    },[])*/

    const handleLoanClick = (index) => {
        if( loanClamps.includes(index) ) {
            setLoanClamps(prev => prev.filter((i => i !== index)))
            return;
        }
        
        setLoanClamps(prev => ([...prev, index]))
    }

    return (
        <>
        <PageHeader/>
    
        <Section title="Értékesítés" additionalClasses="payment-informations pb-0">
            

            <div className="row">
                <div className="col-12 mb-4 font-semibold text-xl" >Személyes találkozó előtt időpontegyeztetés szükséges!</div>
            </div>
        

            <div className="row up">
                <div className="col-12 mb-2">
                    <h3 className="mb-2">Fizetési ütemezés</h3>
                    <span>Érdemes nálunk vásárolnod új építésű lakásod, hiszen kedvező fizetési feltételekkel juthatsz hozzá álmaid otthonához.</span>
                </div>
                <ul className="mb-5">
                    <li>Regisztrációkor 2 000 000 Ft - szerződéskötési biztosíték</li>
                    <li>10% szerződéskötéskor</li>
                    <li>40% szerződéskötés után 30 nappal</li>
                    <li>A vételár fennmaradó része, birtokbaadáskor</li>
                    <li>Az ügyvédi költség a vevőt terheli</li>
                </ul>
            </div>

            <div className="row justify-content-center mt-2">
                <div className="col-lg-12 col-12 single-item large">
                    <Img src={otSzazalekImg} alt="Lakásaink mindössze 5% ÁFA-val megvásárolhatóak."/>
                    <div className="title">5% ÁFA</div>
                    <div className="description">Lakásainkat mindössze <b>5% áfával</b> tudod megvásárolni.</div>
                </div>
                    {/*
                <div className="col-xl-4 col-lg-6 col-12 single-item">
                    <Img src={zoldhitelImg} alt="NHP Zöld Otthon Program"/>
                    <div className="title">NHP Zöld Otthon Program</div>
                    <div className="description"> Élj az „NHP Zöld Otthon Program” keretein belül nyújtott lakáshitel lehetőséggel. Az úgynevezett zöld hitel, szinte minden banknál elérhető, picit eltérő konstrukciókkal. A hitel egyetlen alkalommal vehető igénybe, <b>legfeljebb 70 millió forint</b> hitelösszegig, <b>maximum 25 évre</b>, a kamat felső határa pedig <b>fix 2,5%</b>. Fontos tudni, hogy az igényléshez szükséged van magyarországi lakcímre, az új ingatlan első tulajdonosának kell lenned, továbbá vállalnod kell, hogy a következő 10 évben az ingatlanban élsz, azt nem adod bérbe.</div>
                </div>
                    */}
                {/*<div className="col-lg-6 col-12 single-item large">
                    <Img src={csokImg} alt="Élj a CSOK adta lehetőségekkel"/>
                    <div className="title">CSOK</div>
                    <div className="description">Új építésű lakásaink nagy része megfelel a CSOK előírásainak. A részletekről érdeklődj a hitelt nyújtó pénzintézeteknél.</div>
                </div>*/}
            </div>
        </Section>

        {/*<Section additionalClasses="pb-0" >*/}
            {/*<div className="row justify-content-between">
                
                <div className="col-lg-8 col-12 dots dots-top-right shifted-text-part-img-container order-md-2 order-lg-1" >
                    <Img src={ boldogCsalad } className="img-fluid" skeletonprops={ { height: 295 } }/>
                </div>

                <div className="col-lg-4 col-12 text-part shift-content-left order-md-1 order-lg-2">
                    <div className="text-part-content">
                        <div className="title">Családi Otthonteremtési Kedvezmény</div>
                        <div className="capital">A Családi Otthonteremtési Kedvezmény (CSOK), egy 2015-ben bevezetett vissza nem térítendő állami támogatás, ahol a gyermeket nevelő, vagy gyermeket vállaló családok, gyermekek számától, ingatlan típusától függően 600.000 Ft – 10.000.000 Ft támogatást kaphatnak.</div>
                        <div className="title mt-4">Kedvezményes CSOK hitel</div>
                        <div className="text">Legalább 2 meglévő, vagy vállalt gyermek esetén, a CSOK támogatást igénylőnek, a támogatás igénylése mellett, lehetősége van kedvezményes CSOK hitel igénylésére is.</div>
                         <div className="text">A felvehető kedvezményes hitel maximális összeg:
                            <ul>
                                <li>2 gyermek esetén: 10.000.000 Ft</li>
                                <li>3 gyermek esetén: 15.000.000 Ft</li>
                                <li>Hitelkamat: 3% (A jogszabályi feltételek teljesítése esetén)</li>
                                <li>Maximális futamidő: 25 év</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>*/}

            {/*<div ref={widgetRef}/>
            </Section>*/}

        <Section title="Hogyan juthatok lakásvásárlási hitelhez?" additionalClasses="pb-0">
            <div className="loan-steps-grid ">
            {
                [
                    {
                        title : "Mérd fel az önerőt!",
                        texts : ["Egy ingatlan megvásárlásához a gyakorlatban legalább 20-30%-os önerőre van szükség. Ez az egyik szempont, ami behatárolja mennyiért tudsz ingatlant venni. Ne felejts el számolni azzal, hogy az ingatlan megvásárlásán kívül lesznek még költségeid, például illeték (4%), ingatlan bebútorozása stb."],
                    },
                    {
                        title : "Készíts háztartási költségvetést!",
                        texts :["Nézd meg, hogy a bevételeid, kiadásaid alapján, mi az az összeg, amit a hitelre tudsz szánni! A hatályos jogszabály alapján a mostanában legnépszerűbb legalább 10 éves kamatperiódusú hitel felvétele esetén a jövedelmed, maximum 50-60%-ig terhelhető hitelekkel. Legalább ilyen fontos, hogy felmérd, mekkora az a törlesztőrészlet, ami neked ténylegesen belefér, és amit hosszú távon is tudsz fizetni."],
                    },
                    {
                        title : "Válasszuk ki a legmegfelelőbb hitelt!",
                        texts : ["Ha megvan az ingatlan, illetve, hogy mennyi hitelre lesz szükséged, ki tudjuk választani a számodra legkedvezőbb megoldást. Mivel a jelenlegi piacon számos konstrukció, és államilag támogatott lehetőség is elérhető, ezért mi az ingatlanértékesítésen kívül díjmentes segítséget nyújtunk, hogyan használd ki az állami támogatásokat úgy, hogy azzal akár önerő nélkül tudj lakást venni, vagy megspórold az illetéket."],
                    },
                    {
                        title : "Előszerződés/Adás-vételi szerződés",
                        texts : ["Miután megvan az ingatlan, és a legkedvezőbb hitelkonstrukciót is kiválasztottuk, az adás-vételi szerződés, vagy előszerződés birtokában el tudjuk indítani a hitelezés folyamatát."],
                    },
                    {
                        title : "Hitelkérelem aláírása, banki beadása",
                        texts : ["A szükséges dokumentumok összegyűjtése után már aláírható a hitelkérelem, amit aztán a mellékletekkel együtt benyújtunk az adott bankfiókba."],
                    },
                    {
                        title : "Értékbecslés, hitelbírálat",
                        texts : ["A bank értékbecslést rendel, amivel felméri a kiszemelt ingatlan értékét. Ezt követően az ingatlan, és jövedelmi adatok alapján hitelt bírál, majd meghozza a döntést a hitellel kapcsolatban."],
                    },
                    {
                        title : "Szerződéskötés",
                        texts :["A pozitív hitelbírálatot követően jön a hitelszerződés megkötése a bankkal, amit utána közjegyzői okiratba is foglalnak."],
                    },
                    {
                        title : "Folyósítási feltételek teljesítése",
                        texts : ["A banki szerződéskötéskor a bank meghatározza azokat a feltételeket, amiknek a teljesítése esetén folyósítja a hitelt az eladó bankszámlájára. A legjellemzőbb ilyen folyósítási feltételek a lakásbiztosítás megkötése és bankra záradékolása, illetve az önerő elutalása, ha még nem történt meg korábban."],
                    },
                    {
                        title : "Folyósítás",
                        texts :["A folyósítási feltételek teljesítését követően a bank elutalja a hitelösszeget az eladó bankszámlájára, ezzel a hitelezési folyamat lezáródik."],
                    },
                ].map((curr, index)=>(
                    <div className={`loan-step-grid-item`} onClick={() => handleLoanClick(index)} key={`LoanItem${index}`}>

                        <div className="loan-step-grid-title-row">
                            <span className="number">{index+1}.</span>
                            <span className="loan-step-grid-title">
                                {curr.title}
                            </span>
                        </div>
                        
                        {curr.texts.map((text,tIndex)=>(
                            <p className={`${loanClamps.includes(index) ? "" : " clamp"}`} key={`Text${tIndex}`}>{text}</p>
                        ))}

                        <div className="more">{loanClamps.includes(index) ? "Kevesebb" : "Tovább"}...</div>
                    </div>
                ))
            }
            </div>
        </Section>

        <Section title="Értékesítőink" additionalClasses="payment-informations pb-0">
            <div className="row justify-content-center">
                <div className="col-xl-4 col-lg-6 col-12 single-item">
                    <Img src={molnarZoltan} alt="Új építésű lakások értékesítője Budapest - Molnár Zoltán értékesítési vezető" style={{ objectFit : "contain", background : "linear-gradient(71deg, #3c3e42, #191b1c)"}}/>
                    <div className="title">Molnár Zoltán</div>
                    <div className="">Értékesítési vezető</div>
                    <a href={`mailto:${"molnar.zoltan@bhgzrt.hu"}`} className="description d-block">molnar.zoltan@bhgzrt.hu</a>
                    <a href={`tel:${"+36203663660"}`} className="d-block">+36203663660</a>
                </div>
            </div>
            
        </Section>

        <Faq data={[
            /* {
                title : "Hogyan juthatok lakásvásárlási hitelhez?",
                description : <div>
                    <span className="mb-1">1. <b>Mérd fel az önerőt!</b> Egy ingatlan megvásárlásához a gyakorlatban legalább 20-30%-os önerőre van szükség. Ez az egyik szempont, ami behatárolja mennyiért tudsz ingatlant venni. Ne felejts el számolni azzal, hogy az ingatlan megvásárlásán kívül lesznek még költségeid, például illeték (4%), ingatlan bebútorozása stb.</span>
                    <span className="mb-1">2. <b>Készíts háztartási költségvetést!</b> Nézd meg, hogy a bevételeid, kiadásaid alapján, mi az az összeg, amit a hitelre tudsz szánni! A hatályos jogszabály alapján a mostanában legnépszerűbb legalább 10 éves kamatperiódusú hitel felvétele esetén a jövedelmed, maximum 50-60%-ig terhelhető hitelekkel. Legalább ilyen fontos, hogy felmérd, mekkora az a törlesztőrészlet, ami neked ténylegesen belefér, és amit hosszú távon is tudsz fizetni.</span>
                    <span className="mb-1">3. <b>Válasszuk ki a legmegfelelőbb hitelt!</b> Ha megvan az ingatlan, illetve, hogy mennyi hitelre lesz szükséged, ki tudjuk választani a számodra legkedvezőbb megoldást. Mivel a jelenlegi piacon számos konstrukció, és államilag támogatott lehetőség is elérhető, ezért mi az ingatlanértékesítésen kívül díjmentes segítséget nyújtunk, hogyan használd ki az állami támogatásokat úgy, hogy azzal akár önerő nélkül tudj lakást venni, vagy megspórold az illetéket.</span>
                    <span className="mb-1">4. <b>Előszerződés/Adás-vételi szerződés:</b> Miután megvan az ingatlan, és a legkedvezőbb hitelkonstrukciót is kiválasztottuk, az adás-vételi szerződés, vagy előszerződés birtokában el tudjuk indítani a hitelezés folyamatát.</span>
                    <span className="mb-1">5. <b>Hitelkérelem aláírása, banki beadása:</b> A szükséges dokumentumok összegyűjtése után már aláírható a hitelkérelem, amit aztán a mellékletekkel együtt benyújtunk az adott bankfiókba.</span>
                    <span className="mb-1">6. <b>Értékbecslés, hitelbírálat:</b> A bank értékbecslést rendel, amivel felméri a kiszemelt ingatlan értékét. Ezt követően az ingatlan, és jövedelmi adatok alapján hitelt bírál, majd meghozza a döntést a hitellel kapcsolatban.</span>
                    <span className="mb-1">7. <b>Szerződéskötés:</b> A pozitív hitelbírálatot követően jön a hitelszerződés megkötése a bankkal, amit utána közjegyzői okiratba is foglalnak.</span>
                    <span className="mb-1">8. <b>Folyósítási feltételek teljesítése:</b> A banki szerződéskötéskor a bank meghatározza azokat a feltételeket, amiknek a teljesítése esetén folyósítja a hitelt az eladó bankszámlájára. A legjellemzőbb ilyen folyósítási feltételek a lakásbiztosítás megkötése és bankra záradékolása, illetve az önerő elutalása, ha még nem történt meg korábban.</span>
                    <span className="mb-1">9. <b>Folyósítás:</b> A folyósítási feltételek teljesítését követően a bank elutalja a hitelösszeget az eladó bankszámlájára, ezzel a hitelezési folyamat lezáródik.</span>
                </div>
            }, */
            /*{
                title: "Mekkora lehet a támogatás összege a CSOK-nál?",
                description: <div className="overflow-x-auto">
                    <span className="mb-1">Új lakás vásárlás, építés</span>
                    <table className="csango-table">
                        <tr>
                            <td><b>Gyerekek száma</b></td>
                            <td><b>Támogatás összege</b></td>
                            <td><b>Hasznos alapterület</b></td>
                        </tr>
                        <tr>
                            <td>1 gyermek</td>
                            <td>600.000 Ft</td>
                            <td>40 m<sup>2</sup> lakás / 70 m<sup>2</sup> lakóház</td>
                        </tr>
                        <tr>
                            <td>2 gyermek</td>
                            <td>2.600.000 Ft</td>
                            <td>50 m<sup>2</sup> lakás / 80 m<sup>2</sup> lakóház</td>
                        </tr>
                        <tr>
                            <td>3 gyermek</td>
                            <td>10.000.000 Ft</td>
                            <td>60 m<sup>2</sup> lakás / 90 m<sup>2</sup> lakóház</td>
                        </tr>
                    </table>
                </div>
            },
            {
                title: "Minek kell megfelelni, hogy megkapjam a CSOK-ot?",
                description: <div className="overflow-x-auto">
                    <span className="mb-1">A CSOK támogatás igénybevételének részletes feltételeit, a vonatkozó kormányrendeletek szabályozzák:
                    <br/>Új lakás: 16/2016. (II. 10.) Korm. rendelet
                    </span>
                    <span className="mb-1">
                    Néhány fontosabb feltétel kiemelve:
                    </span>
                    <span className="mb-1">
                    Személyi feltételek:
                    CSOK támogatást házastársak, élettársak, egyedülállók igényelhetnek meglévő gyermekeik után.
                    Gyermeknek minősül:
                    </span>
                    <ul className="mb-5">
                        <li>a magzat vagy az ikermagzat a várandósság betöltött 12. hetét követően, valamint</li>
                        <li>aki az igénylő vér szerinti vagy örökbefogadott eltartott gyermeke és</li>
                        <li className="list-style-type-none">
                            <ul>
                            <li>a 25. életévét még nem töltötte be vagy</li>
                            <li>a 25. életévét már betöltött, megváltozott munkaképességű személy;</li>
                            </ul>
                        </li>
                    </ul>
                    <span className="mb-1">
                    A fiatal házaspárok (Legalább az egyik fél még nem töltötte be a 40. életévét) vállalhatnak is gyermeket (Új lakás - CSOK-nál maximum 3 gyermeket).
                    <br/>A CSOK-ot igénylő személyeknek ezen felül büntetlen előéletűnek kell lenni, és nem lehet köztartozásuk.
                    <br/>Az igénylők legalább egyikének igazolni kell folyamatos biztosítási jogviszonyt. A jogviszony szükséges hossza CSOK típustól, és gyerekszámtól függ:
                    </span>
                    <ul className="mb-5">
                        <li>Új lakás, lakóház építés, vásárlás (2 gyermekig): 180 nap</li>
                        <li>Új lakás, lakóház építés, vásárlás (3 gyermek): 2 év</li>
                    </ul>
                    <span className="mb-4">
                    A személyi feltételeken túl az ingatlanra vonatkozóan is vannak feltételek. Többek között gyermekenként meg van határozva, hogy mekkora az a minimális hasznos alapterület, amivel az ingatlannak rendelkeznie kell.
                    </span>
                    <span className="mb-1">
                        A hasznos alapterület elvárás az alábbiak szerint alakul:
                    <br/>Új lakás vásárlás, építés
                    <table className="csango-table">
                        <tr>
                            <td><b>Gyerekek</b></td>
                            <td><b>Hasznos alapterület</b></td>
                        </tr>
                        <tr>
                            <td>1 gyermek</td>
                            <td>40 m<sup>2</sup> lakás / 70 m<sup>2</sup> lakóház</td>
                        </tr>
                        <tr>
                            <td>2 gyermek</td>
                            <td>50 m<sup>2</sup> lakás / 80 m<sup>2</sup> lakóház</td>
                        </tr>
                        <tr>
                            <td>3 gyermek</td>
                            <td>60 m<sup>2</sup> lakás / 90 m<sup>2</sup> lakóház</td>
                        </tr>
                    </table>
                    </span>
                </div>
            },*/
            /*{
                title : "Mit kell tudnom az adó-visszatérítési kedvezményről?",
                description : <div>
                    <span className="mb-1">
                    Új lakás vásárlása esetén:
                    <br/>Amennyiben maximum 150 m2 alapterületű lakás vásárláshoz CSOK-ot is igénybe veszel, akkor a vételár 5%-os ÁFA tartalmát visszaigényelheted.
                    <br/>Támogatás maximális mértéke:
                    </span>
                    <ul className="mb-1">
                        <li>27%-os ÁFA tartalom esetén: 5.000.000 Ft</li>
                        <li>5%-os ÁFA tartalom esetén: Nincs felső korlát</li>
                        <li>5%-os ÁFÁ-t csak CSOK igénybevétele esetén lehet visszaigényelni.</li>
                    </ul>
                </div>
            },*/
            /* { 
                title : "Mikor lesz az átadás?",
                description : <div>
                    <span className="mb-1">Lakásaink várhatóan 2024.02.29-én kerülnek átadásra.</span>
                </div>
            }, */
            /*{ 
                title : "Hogyan vásárolhatom meg a Csángó10 társasházban jövendőbeli lakásomat?",
                description : <div>
                    <span className="mb-1">Keresd fel értékesítő kollégáinkat, akik készséggel állnak rendelkezésedre és segítenek kiválasztani a legmegfelelőbb lakást.</span>
                </div>
            },*/
            /* { 
                title : "Szerkezetkész állapotban is megvásárolhatom a lakást?",
                description : <div>
                    <span className="mb-1">Igen, az építkezés bármely szakaszában lehetőség van a vásárlásra.</span>
                </div>
            }, */
            {
                title : "A társasház jogerős használatbavételi engedéllyel rendelkezik?",
                description : "Igen.",
            },
            {
                title : "A társasház sikeresen bejegyzésre került?",
                description : "Igen.",
            },
            {
                title : "A lakások azonnal költözhetőek?",
                description : "Igen.",
            },
            { 
                //2024.06.06 - Ugyan MZoli "megnézte" és "nem találta", de benne volt, hogy az eladót terhelik az ügyvédi költségek.
                //Mostantól a vásárlót terhelik ezek a költségek.
                title : "Kit terhelnek az ügyvédi költségek?",
                description : <div>
                    <span className="mb-1">A vevőt.</span>
                </div>
            },
            { 
                title : "A burkolatokat én választom ki?",
                description : <div>
                    <span className="mb-1">Igen.</span>
                    <ul>
                        <li>Duravit D-CODE szaniterek</li>
                        <li>GROHE csaptelepek</li>
                        <li>Olasz I. osztályú hidegburkolatok/kerámiák</li>
                        <li>Jaffholz ajtók - többféle színben</li>
                    </ul>
                    <span className="mb-1 mt-2">Részletekért keresd értékesítőinket.</span>
                </div>
            },
            { 
                title : "Hozhatok saját burkolatokat is?",
                description : <div>
                    <span className="mb-1">Nem, kivitelezőink a meghatározott termékekkel dolgoznak.</span>
                </div>
            },
            { 
                title : "A konyhabútor benne van a vételárban?",
                description : <div>
                    <span className="mb-1">Nem, a konyhabútor nem része a műszaki tartalomnak.</span>
                </div>
            },
            /*{ 
                title : "Mi a különbség a bruttó és a nettó alapterület között?",
                description : <div>
                    <span className="mb-1">A bruttó terület a falakkal együtt mért területet jelenti.</span>
                    <span className="mb-1">A nettó terület a falak nélkül mért területet jelenti.</span>
                </div>
            },
            { 
                title : "Milyen támogatások igénybevételére van lehetőségem?",
                description : <div>
                    <ul>
                        <li>Lakástakarékpénztár (LTP)</li>
                        <li>Családok otthonteremtési támogatása (CSOK)</li>
                        <li>Kamattámogatott lakáshitel</li>
                    </ul>
                    <span className="mb-1 mt-2">Ezen támogatások abban az esetben vehetők igénybe, ha a vásárló minden feltételnek megfelel.</span>
                </div>
            },*/
            { 
                title : "Van lehetőségem hitelfelvételre a vásárláshoz?",
                description : <div>
                    <span className="mb-1">Természetesen igen.</span>
                </div>
            },
        ]}/>

        </>
    )
}

export default PaymentInformations;